import { APP_TYPE } from './APP_TYPE.js';
export const URL_APP_TYPE = {
    [APP_TYPE.CUSTOMER_PORTAL]: 'cp',
    [APP_TYPE.CXEURO]: 'cxeuro',
    [APP_TYPE.CXNA]: 'cxna',
    [APP_TYPE.CXNA_BROKER]: 'broker',
    [APP_TYPE.CXNA_CARRIER]: 'carrier',
    [APP_TYPE.CXNA_EXPERDITER]: 'expediter',
    [APP_TYPE.CX]: 'cx',
    [APP_TYPE.FLS]: 'fls',
    [APP_TYPE.FSDF]: 'coldchain',
    [APP_TYPE.HX]: 'hx',
    [APP_TYPE.IFEX]: 'ifex',
    [APP_TYPE.INTEGRA]: 'integra',
    [APP_TYPE.LENDER_PORTAL]: 'lender_portal',
    [APP_TYPE.LENS]: 'lens',
    [APP_TYPE.SF]: 'sf',
    [APP_TYPE.TFX]: 'timedfx',
    [APP_TYPE.TPN]: 'tpnplus',
    [APP_TYPE.LOGIQUANTA]: 'logiquanta',
    [APP_TYPE.TEG]: 'teg',
};
export default URL_APP_TYPE;
